export default {
  报价管理: "报价管理",
  样品管理: "样品管理",
  脚本审核: "脚本审核",
  草稿审核: "草稿审核",
  交付内容: "交付内容",
  打款信息: "打款信息",
  商单PM: "商单PM",
  "复制成功！": "复制成功！",
  "商单已交付或已取消，不可操作，已为您刷新页面！":
    "商单已交付或已取消，不可操作，已为您刷新页面！",
  达人要求: "达人要求",
  粉丝量: "粉丝量",
  目标接单达人数: "目标接单达人",
  "平均预算/达人": "平均预算/达人",
  目标总预算: "目标总预算",
  邀约达人时间: "邀约达人时间",
  目标交付时间: "目标交付时间",
  查看详情: "查看详情",
  邀约中: "邀约中",
  已接单: "已接单",
  已取消: "已取消",
  达人唯一名: "达人唯一名",
  达人昵称: "达人昵称",
  达人: "达人",
  粉丝数: "粉丝数",
  邀约报价: "邀约报价",
  操作: "操作",
  修改报价: "修改报价",
  复制邀请链接: "复制邀请链接",
  取消邀约: "取消邀约",
  新增邀约达人: "新增邀约达人",
  邀约达人: "邀约达人",
  已邀约达人不可重复添加: "已邀约达人不可重复添加",
  请输入TikTok账号唯一名: "请输入TikTok账号唯一名",
  请输入金额: "请输入金额",
  修改后达人的商单邀请将同步更新: "修改后达人的商单邀请将同步更新",
  请输入取消邀约理由: "请输入取消邀约理由",
  "最多可输入100个字，请简短说说为什么。": "最多可输入100个字，请简短说说为什么。",
  "取消成功！": "取消成功！",
  "修改成功！": "修改成功！",
  "添加成功！": "添加成功！",
  "达人已申请样品，不可取消接单！": "达人已申请样品，不可取消接单！",
  导出数据: "导出数据",
  接单达人: "接单达人",
  选择操作: "选择操作",
  修改最终报价: "修改最终报价",
  取消接单: "取消接单",
  新增接单达人: "新增接单达人",
  已接单达人不可重复添加: "已接单达人不可重复添加",
  "该达人已接单您的邀请，请勿重复添加！": "该达人已接单您的邀请，请勿重复添加！",
  接单报价: "接单报价",
  "请和达人确认后修改，否则由PIC自行承担责任！": "请和达人确认后修改，否则由PIC自行承担责任！",
  最终报价: "最终报价",
  请输入取消接单理由: "请输入取消接单理由",
  接单时间: "接单时间",
  取消时间: "取消时间",
  取消理由: "取消理由",
  "自动取消，已被其他PIC谈成！": "自动取消，已被其他PIC谈成！",
  商单已交付: "商单已交付",
  待申样: "待申样",
  已申样: "已申样",
  申请样品: "申请样品",
  商单: "商单",
  新建样品订单: "新建样品订单",
  报价: "报价",
  申样达人名称: "申样达人名称",
  可履约方式: "可履约方式",
  "该达人粉丝数＜20K": "该达人粉丝数＜20K",
  收件人姓名: "收件人姓名",
  收件人电话: "收件人电话",
  地区: "地区",
  详细地址: "详细地址",
  "请输入街道名称，公寓名称，房间号": "请输入街道名称，公寓名称，房间号",
  商单商品: "商单商品",
  商品ID: "商品ID",
  添加规格: "添加规格",
  规格: "规格",
  数量: "数量",
  请输入有效的手机号: "请输入有效的手机号",
  申样数量: "申样数量",
  样品详情: "样品详情",
  追加申样: "追加申样",
  待审核: "待审核",
  待发货: "待发货",
  待履约: "待履约",
  已拒绝: "已拒绝",
  合格: "合格",
  不合格: "不合格",
  待上传: "待上传",
  待收款: "待收款",
  已收款: "已收款",
  交付视频: "交付视频",
  标题: "标题",
  Hashtag达标: "Hashtag达标",
  挂链正确: "挂链正确",
  时长达标: "时长达标",
  "Ads Code": "Ads Code",
  播放量: "播放量",
  "销量（TAP link）": "销量（TAP link）",
  校验人: "校验人",
  系统自动: "系统自动",
  人工校验: "人工校验",
  其他理由: "其他理由",
  确认合格: "确认合格",
  重新上传: "重新上传",
  确认商单商品合格: "确认商单商品合格",
  "请勾选以下要求，人工确认已合格": "请勾选以下要求，人工确认已合格",
  Hashtag: "Hashtag",
  "TAP link": "TAP link",
  视频时长: "视频时长",
  交付视频合格: "交付视频合格",
  "该视频将标记为合格视频，你还要继续吗？":
    '<span style="color: red">该视频将标记为合格视频</span>，你还要继续吗？',
  "请勾选以理由，将在APP展示给达人": "请勾选以理由，将在APP展示给达人",
  Hashtag错误: "Hashtag错误",
  "TAP link未挂链": "TAP link未挂链",
  视频时长未达标: "视频时长未达标",
  "Ads Code未填或填写错误": "Ads Code未填或填写错误",
  不超过20个字: "不超过20个字",
  不合格理由: "不合格理由",
  "请输入该视频的Ads Code": "请输入该视频的Ads Code",
  仅展示信息有误: "仅展示信息有误",
  履约状态: "履约状态",
  已交付: "已交付",
  应付商单费用: "应付商单费用",
  收款类型: "收款类型",
  未上传: "未上传",
  信息有误: "信息有误",
  个人: "个人",
  公司: "公司",
  银行信息: "银行信息",
  收款人: "收款人",
  收款银行: "收款银行",
  收款卡号: "收款卡号",
  查看凭证: "查看凭证",
  手机号: "手机号",
  身份证信息: "身份证信息",
  姓名: "姓名",
  性别: "性别",
  称呼: "称呼",
  身份证号: "身份证号",
  身份证居住地址: "身份证居住地址",
  营业执照: "营业执照",
  添加收款信息: "添加收款信息",
  编辑收款信息: "编辑收款信息",
  "必填项未填！": "必填项未填！",
  个人收款: "个人收款",
  公司收款: "公司收款",
  收款信息: "收款信息",
  联系电话: "联系电话",
  收款人性别: "收款人性别",
  小姐: "小姐",
  女士: "女士",
  先生: "先生",
  身份证姓名: "身份证姓名",
  请输入身份证居住地址: "请输入身份证居住地址",
  身份证号码: "身份证号码",
  银行卡号: "银行卡号",
  身份证照片: "身份证照片",
  银行信息截图: "银行信息截图",
  确认通过: "确认通过",
  "确认收款信息无误可以打款，你还要继续吗？":
    '<span style="color: red">确认收款信息无误可以打款</span>，你还要继续吗？',
  收款信息有误: "收款信息有误",
  "请填写理由，将在APP展示给达人": "请填写理由，将在APP展示给达人",
  不超过50个字: "不超过50个字",
  银行信息凭证: "银行信息凭证",
  银行凭证: "银行凭证",
  关闭: "关闭",
  保存: "保存",
  居住地址: "居住地址",
  "该信息已审核通过或已打款，不可保存修改内容": "该信息已审核通过或已打款，不可保存修改内容",
  营业执照凭证: "营业执照凭证",
  收款信息审核人: "收款信息审核人",
  导入数据: "导入数据",
  确认打款: "确认打款",
  请输入打款时间: "请输入打款时间",
  打款时间: "打款时间",
  打款类型: "打款类型",
  打款操作人: "打款操作人",
  通过: "通过",
  已打款: "已打款",
  系统审核中: "系统审核中",
  身份证凭证: "身份证凭证",
  修改收款信息: "修改收款信息",
  公司营业执照: "公司营业执照",
  收款人称呼: "收款人称呼",
  进行中: "进行中",
  "申样成功，请前往样品申样查看！": "申样成功，请前往样品申样查看！",
  前往样品申样: "前往样品申样",
  "操作成功！": "操作成功！",
  请勾选所有要求: "请勾选所有要求",
  必需: "必需",
  非必需: "非必需",
  商单报价: "商单报价",
  VAT: "VAT",
  商单总价: "商单总价",
  含VAT: "含VAT",
  WHT: "WHT",
  代扣税额: "代扣税额",
  应打款金额: "应打款金额",
  "Net Pay": "Net Pay",
  含税: "含税",
  请输入有效的银行卡号: "请输入有效的银行卡号",
  请输入有效的身份证号: "请输入有效的身份证号",
  已完成: "已完成",
  待打款: "待打款",
  总订单数: "总订单数",
  请人工校验: "请人工校验",
  刷新: "刷新",
  成功商品数: "成功商品数",
  失败商品数: "失败商品数",
  个税: "个税",
  "不可打款-未履约": "不可打款-未履约",
  "可打款-已履约": "可打款-已履约"
};
